import { createRoutine } from 'redux-saga-routines';

export const verifyAddressRoutine = createRoutine('USPS/VERIFY_ADDRESS');

export const verifyZipRoutine = createRoutine('USPS/VERIFY_ZIP');
